<template>
  <div>
    <hr/>
    <label class="label pb-2">Instancer</label>
    <b-field label="Template Name" label-position="on-border">
      <b-input v-model="template.template_name" placeholder="Template name" />
    </b-field>
    <b-field label="Timeout (seconds)" label-position="on-border">
      <b-input type="number" min="0" step="1" v-model.number="template.timeout" placeholder="3600" />
    </b-field>
    <b-field label="Connection Info Format (HTML)" label-position="on-border">
      <b-input type="textarea" v-model="template.conn_info_format" placeholder="Optional HTML format string. Use {conn_info} as placeholder for the connection info." rows="4" />
    </b-field>
    <p class="help">Leave empty to use default format. Use <code>{conn_info}</code> in your HTML to insert the connection info string.</p>
  </div>
</template>

<script>
export default {
  props: {
    challengeId: {
      type: Number,
      required: false,
      default: null,
    },
    challengeName: {
      required: false,
    },
    isEditing: Boolean,
    challenge: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      template: {
        template_name: '',
        timeout: null,
        conn_info_format: '',
      },
    };
  },
  methods: {
    async loadTemplate(challengeId) {
      if (!challengeId) return;
      try {
        const resp = await this.$ctforge.api.get(`/instancer/admin/template?challenge_id=${challengeId}`);
        this.template = {
          template_name: resp.template_name,
          timeout: resp.timeout,
          conn_info_format: resp.conn_info_format || '',
        };
      } catch (e) {
        this.notify(e.message, 'is-danger');
      }
    },
    async submit(id) {
      const challengeId = id || this.challengeId;
      if (!challengeId) return;
      try {
        await this.$ctforge.api.post('/instancer/admin/template', {
          challenge_id: challengeId,
          template_name: this.template.template_name || null,
          timeout: this.template.timeout,
          conn_info_format: this.template.conn_info_format || null,
        });
      } catch (e) {
        this.notify(e.message, 'is-danger');
      }
    },
  },
  watch: {
    challengeId: {
      handler(value) {
        if (this.isEditing) this.loadTemplate(value);
      },
      immediate: true,
    },
  },
};
</script>
